import { Navigate, RouteObject } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import {
  AudioList,
  Collaborators,
  ContributionsList,
  SongDetails,
} from 'app/components/Song';
import React from 'react';
import { Lyrics } from 'app/components/Song/Lyrics';
import { SplitsRoute } from 'app/routing/components/SplitsRoute';

export const songRoutes: RouteObject[] = [
  { path: routes.songAudioList.route, element: <AudioList /> },
  { path: routes.songLyrics.route, element: <Lyrics /> },
  { path: routes.songContributions.route, element: <ContributionsList /> },
  { path: routes.songSplits.route, element: <SplitsRoute /> },
  { path: routes.songCollaborators.route, element: <Collaborators /> },
  { path: routes.songDetails.route, element: <SongDetails /> },
  { path: '', element: <Navigate to={routes.songAudioList.route} replace /> },
];
